import { FC, useCallback } from 'react';

import { Country } from '@/interfaces/billing';

import { CountrySelector } from './CountrySelector';
import { PhoneInput } from './PhoneInput';

interface CountryPhoneSelectorProps {
  value?: { number: string; codeCountry: string }
  onChange: (value: { number: string; codeCountry: string }) => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

export const CountryPhoneSelector: FC<CountryPhoneSelectorProps> = ({
  value,
  onChange,
  placeholder = 'Número de teléfono',
  disabled = false,
  className,
}) => {
  // Handle country selection change
  const handleCountryChange = useCallback(
    (country: Country) => {
      onChange({
        number: value?.number || '',
        codeCountry: country.prefix,
      })
    },
    [value?.number, onChange]
  )

  // Handle phone number change
  const handlePhoneChange = useCallback(
    (phoneNumber: string) => {
      onChange({
        number: phoneNumber,
        codeCountry: value?.codeCountry || '+53',
      })
    },
    [value?.codeCountry, onChange]
  )

  return (
    <div className="flex gap-2">
      <CountrySelector
        value={value?.codeCountry}
        onChange={handleCountryChange}
        valueType="prefix"
        showFlag={true}
        showPrefix={true}
        searchPlaceholder="Buscar país o código..."
        triggerClassName="w-[120px]"
        compactMode={true}
        disabled={disabled}
        contentClassName="w-[220px]"
        className={className}
      />
      <div className="flex-1">
        <PhoneInput
          value={value?.number}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
        />
      </div>
    </div>
  )
}
